export default "__VITE_ASSET__1a80b8a0__"